export default __webpack_public_path__ + "static/img1-3d2cf4e5e7343aabe0bf591966b08ba7.png";